import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { SwalService } from '@shared/utils/swal.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SimuladorService } from '@p-p-portafolio/promociones/services/simulador.service';
import { ProDefinicionesService } from '@p-p-portafolio/services/pro-definiciones.service';
import { Location } from '@angular/common';
import { SharedDataService } from '@shared/utils/shared-data.service';
import * as moment from 'moment';
import { UserService } from '@pages/user/services/user.service';
import { SessionService } from '@shared/helpers/sesion.service';
import { concat } from 'rxjs';

interface IPayment {
  iValor: string;
  sEtiqueta: string;
}

interface ValoresSimula {
  usuario: string;
  accion: number;
  promocion: string;
  idValor: number;
  valor: number;
  tipoCalculo: number;
  plazVar: number;
  numClient: string;
  mulOdbc: number;
}

interface SimulaPromocion {
  usuario: string;
  numSol: string;
  mulOdbc: any;
  cesion: number;
  credCes: number;
  promocion: string;
  fecha: number;
  fechaStr: string;
  ciclo: number;
  deDonde: number;
  identTabla: number;
  regresa: number;
}

interface SimulaEfectivo {
  usuario: string;
  accion: number;
  identTabla: number;
}

interface SimulaComision {
  usuario: string;
  accion: number;
  identTabla: number;
}

@Component({
  selector: 'app-simulador',
  templateUrl: './simulador.component.html',
  styleUrls: ['./simulador.component.css']
})
export class SimuladorComponent implements OnInit {
  private _user: string = this._userServices.userCurrent;
  public mostrarCuotaInicial: boolean = true;
  public mostrarEfectivo: boolean = false;
  dynamicFields = [];
  promocion = '';
  numvarPlazos = 0;
  terms: any;
  cicles: any;
  termsNumVar: any[] = [];
  payments: IPayment[] = [];
  variables: any[] = [];
  varBool: boolean[] = [];
  varStr: string[] = [];
  public categorias: any[] = [];
  public loading: boolean = false;
  public data: any;
  private isSimulando: boolean = false;

  form = this.fb.group({
    monto: [''],
    plazo: [''],
    ciclo: [''],
    cuotaInicial: ['']
  });

  dataSource: any[] = [];
  efectivosource: any[] = [];
  public columns: string[] = ['Pago', 'FechaPago', 'dias', 'PagoCap', 'PagoInt', 'Saldo'];

  public efectivo: string[] = ['descripcion', 'valor', 'valoriva'];

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private _simuladorServices: SimuladorService,
    private _router: Router,
    private _userServices: UserService,
    private _location: Location,
    private _swalService: SwalService,
    private _dataShareService: SharedDataService,
    private _sessionService: SessionService
  ) {}

  ngOnInit(): void {
    const routeParams = this.route.snapshot.paramMap;
    this.promocion = String(routeParams.get('promocion'));
    this.cargarCicle();
    this.cargarTerm();
    this.cargarPayments();
    this._dataShareService.currentData$.subscribe((res) => {
      const setModel = {
        sPromocion: res.sPromocion,
        descripcion: res.descripcion,
        claseCart: res.claseCart,
        plazoMin: res.plazoMin,
        plazoMax: res.plazoMax,
        sEmpresa: res.sEmpresa,
        sSucursal: res.sSucursal,
        sFechaI: moment(res.sFechaI, 'DD/MM/YYYY').toDate(),
        sFechaF: moment(res.sFechaF, 'DD/MM/YYYY').toDate(),
        moneda: res.moneda,
        sCartera: res.sCartera,
        producto: res.producto,
        user: this._user
      };
      this.data = setModel;
    });
    // Primero ejecutar acción 3, luego acción 0
    this.GetAmortizacionValoresSimula(3);
  }

  getControlName(campo: any): string {
    return campo.descripcion.trim().replace(/\s+/g, '_').toLowerCase();
  }

  goBack() {
    window.history.back();
  }

  GetAmortizacionValoresSimula(accion: number) {
    let payload: ValoresSimula = {
      usuario: this._sessionService.getUserSession(),
      accion: accion,
      promocion: this.promocion,
      idValor: 0,
      valor: 0,
      tipoCalculo: 0,
      plazVar: 0,
      numClient: '',
      mulOdbc: 0
    };

    this._simuladorServices.AmortizacionValoresSimula(payload).subscribe({
      next: (res) => {
        if (payload.accion == 3) {
          // Después de acción 3, ejecutar acción 0
          this.GetAmortizacionValoresSimula(0);
        } else if (payload.accion == 0) {
          const max = parseFloat(res[0].dPorcEnganMax);
          const min = parseFloat(res[0].dPorcEnganMin);
          
          // Solo validar el enganche si NO estamos simulando (carga inicial)
          if (!this.isSimulando) {
            const enganche = parseFloat(this.form.value.monto || 0);

            // Valida si el enganche está fuera del rango
            if (!isNaN(enganche) && enganche > 0 && (enganche > max || enganche < min)) {
              this.loading = false;
              this._swalService.error('El enganche ingresado no es válido.');
              return;
            }
          }
          
          this.mostrarCuotaInicial = max !== 0;
          
          // Si estamos simulando, continuar con la acción 1
          if (this.isSimulando) {
            this.GetAmortizacionValoresSimula(1);
          } else {
            this.GetAmortizacionValoresSimula(1);
          }
        } else if (payload.accion == 1) {
          if (!this.isSimulando) {
            try {
              if (Array.isArray(res)) {
                this.camposDinamicosAccion1(res);
              } else {
                // Si el backend no devuelve array, no hay campos dinámicos
                this.dynamicFields = [];
              }
            } catch (e) {
              console.warn('No se pudieron construir campos dinámicos:', e);
              this.dynamicFields = [];
            }
            return;
          }

          // procesarFormularioParaAccion2 ahora ejecuta AmortizacionSimulaPromocion cuando termina
          this.procesarFormularioParaAccion2();
          this.isSimulando = false; // Resetear el flag después de procesar
        }
      },
      error: (err) => {
        console.log(err);
        if (payload.accion == 1) {
          this.loading = false;
          this.isSimulando = false;
          this._swalService.error('Error al procesar la simulación.');
        } else if (payload.accion == 0 && this.isSimulando) {
          this.loading = false;
          this.isSimulando = false;
          this._swalService.error('Error al validar el enganche.');
        } else if (payload.accion == 3 && this.isSimulando) {
          this.loading = false;
          this.isSimulando = false;
          this._swalService.error('Error al inicializar la simulación.');
        }
      }
    });
  }

  private camposDinamicosAccion1(res: any) {
    // Limpiar los controles previos
    Object.keys(this.form.controls).forEach((control) => {
      this.form.removeControl(control);
    });

    // Redefinir los campos base
    this.form = this.fb.group({
      ciclo: [''],
      monto: [''],
      plazo: ['', Validators.required],
      cuotaInicial: ['']
    });

    // Filtrar los campos dinámicos donde el tipo es "0"
    this.dynamicFields = res.filter((campo) => campo.tipo === '0');

    // Asignar numvarPlazos dinámicamente según el iTipoCalculo === "3"
    this.dynamicFields.forEach((campo) => {
      if (campo.iTipoCalculo === '3') {
        this.numvarPlazos = parseInt(campo.numvar, 10); // Asigna el numvar correspondiente
      }
    });
    // Cargar los plazos solo una vez (si aplica)
    if (this.numvarPlazos) {
      this.cargarTermsPlazos();
    }

    // Agregar controles dinámicos según la respuesta
    this.dynamicFields.forEach((campo) => {
      let controlName = campo.descripcion.trim().replace(/\s+/g, '_').toLowerCase(); // Nombre del campo sin espacios y en minúsculas
      if (campo.valor === '1') {
        // Si el valor es "1", se presenta un campo numérico
        this.form.addControl(controlName, this.fb.control('', [Validators.pattern('^[0-9]*$')]));
      }

      if (campo.iTipoCalculo === '3') {
        // Si iTipoCalculo es "3", se presentan los campos pago y plazo
        this.form.addControl(`${controlName}_Pago`, this.fb.control(''));
        this.form.addControl(`${controlName}_Plazo`, this.fb.control(''));
      }
    });
  }

  private procesarFormularioParaAccion2() {
    let groupedPayloads: { [key: number]: ValoresSimula } = {}; // Agrupar datos por numvar
    const llamadasEstaticas: any[] = [];
    
    // Orden específico de campos estáticos según los ejecutables SQL: ciclo (-1), plazo (1), cuotaInicial (2), monto (0)
    // Mapeo de campos a sus idValor correspondientes
    const camposEstaticosOrdenados: { campo: string, idValor: number }[] = [
      { campo: 'ciclo', idValor: -1 },
      { campo: 'plazo', idValor: 1 },
      { campo: 'cuotaInicial', idValor: 2 },
      { campo: 'monto', idValor: 0 }
    ];

    // Primero procesar campos estáticos en el orden correcto
    camposEstaticosOrdenados.forEach((item) => {
      if (this.form.controls[item.campo]) {
        let valorCampo = this.form.get(item.campo)?.value || 0;
        let payload: ValoresSimula = {
          usuario: this._sessionService.getUserSession(),
          accion: 2,
          promocion: this.promocion,
          idValor: item.idValor,
          valor: valorCampo,
          tipoCalculo: 0,
          plazVar: 0,
          numClient: '',
          mulOdbc: 0
        };

        // Guardar la llamada para esperar a que termine
        llamadasEstaticas.push(
          this._simuladorServices.AmortizacionValoresSimula(payload)
        );
      }
    });

    // Luego procesar campos dinámicos
    const nombresCamposEstaticos = camposEstaticosOrdenados.map(item => item.campo);
    Object.keys(this.form.controls).forEach((key) => {
      // Saltar campos estáticos que ya procesamos
      if (nombresCamposEstaticos.includes(key)) {
        return;
      }

      let valorCampo = this.form.get(key)?.value || 0;

      // Detectar si es un campo dinámico
      let campo = this.dynamicFields.find((c) => key.startsWith(c.descripcion.trim().replace(/\s+/g, '_').toLowerCase()));

      if (campo) {
        // Campo dinámico: usar numvar como idValor
        let numvar = parseInt(campo.numvar, 10);

        if (!groupedPayloads[numvar]) {
          groupedPayloads[numvar] = {
            usuario: this._sessionService.getUserSession(),
            accion: 2,
            promocion: this.promocion,
            idValor: numvar,
            valor: 0,
            tipoCalculo: 0,
            plazVar: 0,
            numClient: '',
            mulOdbc: 0
          };
        }

        let baseControlName = campo.descripcion.trim().replace(/\s+/g, '_').toLowerCase();
        if (key === baseControlName) {
          groupedPayloads[numvar].valor = parseInt(valorCampo, 10);
        }

        // Si iTipoCalculo es "3", asignar _Pago y _Plazo
        if (campo.iTipoCalculo === '3') {
          if (key.toUpperCase().includes('_PAGO')) {
            groupedPayloads[numvar].tipoCalculo = parseInt(valorCampo, 10);
          }
          if (key.toUpperCase().includes('_PLAZO')) {
            groupedPayloads[numvar].plazVar = parseInt(valorCampo, 10);
          }
        }
      }
    });

    // Enviar una sola petición por cada numvar (solo para los dinámicos)
    Object.values(groupedPayloads).forEach((payload) => {
      llamadasEstaticas.push(
        this._simuladorServices.AmortizacionValoresSimula(payload)
      );
    });

    // Ejecutar las llamadas de forma secuencial (una después de otra) como en SQL
    if (llamadasEstaticas.length > 0) {
      // Usar concat para ejecutar secuencialmente
      concat(...llamadasEstaticas).subscribe({
        next: (res) => {},
        complete: () => {
          // Todas las llamadas de acción 2 terminaron secuencialmente, ahora ejecutar SimulaPromocion
          this.AmortizacionSimulaPromocion();
        },
        error: (err) => {
          console.log('Error en procesarFormularioParaAccion2:', err);
          // Aun así ejecutar SimulaPromocion
          this.AmortizacionSimulaPromocion();
        }
      });
    } else {
      // Si no hay llamadas, ejecutar directamente
      this.AmortizacionSimulaPromocion();
    }
  }

  AmortizacionSimulaPromocion() {
    let payload: any = {
      sUsuario: this._sessionService.getUserSession(),
      sNumSol: '',
      iMulOdbc: 0,
      iCesion: 0,
      iCredCes: 0,
      sPromocion: this.promocion,
      iFecha: 0,
      sFecha: '',
      iCiclo: 0,
      iDeDonde: 1,
      identTabla: 0,
      dRegresa: 0
    };
    this._simuladorServices.SimulaPromocion(payload).subscribe({
      next: (res) => {
        if (res.success && res.data && res.data.length > 0) {
          // Mapear la respuesta de camelCase a PascalCase para mantener compatibilidad
          const dataMapeada = this.mapearRespuestaSimulacion(res.data);
          const consecutivo = Number(dataMapeada[0]?.consecutivo || 0);
          this.cargarNombresVariablesYConstruirColumnas(dataMapeada);
          this.AmortizacionSimulaEfectivo(consecutivo);
          this.CargaInfoTabla(dataMapeada);
        } else {
          this.loading = false;
          this._swalService.error('No se pudo obtener la información de la simulación.');
        }
      },
      error: (err) => {
        console.log(err);
        this.loading = false;
        this._swalService.error('Error al simular la promoción.');
      }
    });
  }


  private mapearRespuestaSimulacion(data: any[]): any[] {
    return data.map((item: any) => {
      const mapeado: any = {
        Pago: item.pago || 0,
        FechaPago: item.fechaPago || '',
        dias: item.dias || 0,
        Saldo: item.saldo || 0,
        PagoCap: item.pagoCap || 0,
        PagoInt: item.pagoInt || 0,
        Suma: item.suma || 0,
        consecutivo: item.consecutivo || 0,
        iError: item.iError || 0
      };

      // Mapear variables dinámicas (var1, var2, ..., var10) y sus variantes
      for (let i = 1; i <= 10; i++) {
        const varKey = `var${i}`;
        if (item[varKey] !== undefined) {
          mapeado[varKey] = item[varKey] || 0;
          const ivaVal = item[`${varKey}iva`] ?? item[`var${i}Iva`];
          mapeado[`${varKey}iva`] = ivaVal !== undefined ? (ivaVal || 0) : 0;
        }
        if (item[`${varKey}int`] !== undefined) {
          mapeado[`${varKey}int`] = item[`${varKey}int`] || 0;
        }
        if (item[`${varKey}ivaint`] !== undefined) {
          mapeado[`${varKey}ivaint`] = item[`${varKey}ivaint`] || 0;
        }
      }

      // Mapear otros campos adicionales
      if (item.amortini !== undefined) mapeado.amortini = item.amortini;
      if (item.subPago !== undefined) mapeado.subPago = item.subPago;
      if (item.pagoExt !== undefined) mapeado.pagoExt = item.pagoExt;

      return mapeado;
    });
  }

  cargarNombresVariablesYConstruirColumnas(data: any) {
    if (!data || data.length === 0) return;
    if (data[0]?.iError && data[0].iError !== 0) {
      this._swalService.error('Error en la simulación. Por favor, verifique los datos ingresados.');
      return;
    }

    const primerItem = data[0];
    const payloadViejo = {
      usuario: this._sessionService.getUserSession(),
      numSol: '',
      mulOdbc: 0,
      cesion: 0,
      credCes: 0,
      promocion: this.promocion,
      fecha: 0,
      fechaStr: '',
      ciclo: this.form.get('ciclo')?.value ?? 0,
      deDonde: 1,
      identTabla: 0,
      regresa: 2
    };

    this._simuladorServices.AmortizacionSimulaPromocion(payloadViejo).subscribe({
      next: (res) => {
        const listaConNombres = Array.isArray(res) ? res : [];
        const mapDescripcion: Record<string, string> = {};
        listaConNombres.forEach((v: any) => {
          if (v.Campo) mapDescripcion[v.Campo] = v.Descripcion || v.Campo;
        });
        for (let i = 1; i <= 10; i++) {
          const varKey = `var${i}`;
          const varKeyIva = `var${i}iva`;
          if (mapDescripcion[varKey] && !mapDescripcion[varKeyIva]) {
            mapDescripcion[varKeyIva] = mapDescripcion[varKey] + ' IVA';
          }
        }
        this.variables = [];
        for (let i = 1; i <= 10; i++) {
          const varKey = `var${i}`;
          const varKeyIva = `var${i}iva`;
          const desc = mapDescripcion[varKey] || `Variable ${i}`;
          const descIva = mapDescripcion[varKeyIva] || desc + ' IVA';
          const val = primerItem[varKey];
          const valIva = primerItem[varKeyIva];
          const mostrarVar = val !== undefined && val !== null && val !== 0 && String(val).trim() !== '';
          const mostrarIva = valIva !== undefined && valIva !== null && valIva !== 0 && String(valIva).trim() !== '';
          if (mostrarVar) this.variables.push({ Campo: varKey, Descripcion: desc });
          if (mostrarIva) this.variables.push({ Campo: varKeyIva, Descripcion: descIva });
        }
        this.actualizarColumns();
      },
      error: () => {
        this.construirVariablesConFallback(primerItem);
        this.actualizarColumns();
      }
    });
  }

  private actualizarColumns() {
    this.columns = ['Pago', 'FechaPago', 'dias', 'Saldo', 'PagoCap', 'PagoInt', 'Suma'];
    const camposToAdd = this.variables.map((item: any) => item.Campo);
    this.columns.splice(6, 0, ...camposToAdd);
  }

  /** Fallback si el API viejo falla: usar dynamicFields y solo columnas con valor distinto de 0. */
  private construirVariablesConFallback(primerItem: any) {
    this.variables = [];
    for (let i = 1; i <= 10; i++) {
      const varKey = `var${i}`;
      const varKeyIva = `var${i}iva`;
      const descripcion = this.dynamicFields?.find((c: any) => parseInt(c.numvar, 10) === i)?.descripcion || `Variable ${i}`;
      const valorVar = primerItem[varKey];
      const valorIva = primerItem[varKeyIva];
      const mostrarVar = valorVar !== undefined && valorVar !== null && valorVar !== 0 && String(valorVar).trim() !== '';
      const mostrarIva = valorIva !== undefined && valorIva !== null && valorIva !== 0 && String(valorIva).trim() !== '';

      if (mostrarVar) {
        this.variables.push({ Campo: varKey, Descripcion: descripcion });
      }
      if (mostrarIva) {
        this.variables.push({ Campo: varKeyIva, Descripcion: descripcion + ' IVA' });
      }
    }
  }

  AmortizacionSimulaEfectivo(consecutivo: number) {
    let payload: SimulaEfectivo = {
      usuario: this._sessionService.getUserSession(),
      accion: 1,
      identTabla: consecutivo
    };
    this._simuladorServices.AmortizacionSimulaEfectivo(payload).subscribe({
      next: (res) => {
        this.mostrarEfectivo = res && res.length > 0;
        if (this.mostrarEfectivo) {
          this.AmortizacionSimulaComision(consecutivo);
          this.CargaInfoTablaEfectivo(res);
        }
        this.loading = false;
      },
      error: (err) => {
        console.log(err);
        this.loading = false;
      }
    });
  }

  AmortizacionSimulaComision(consecutivo: number) {
    let payload: SimulaComision = {
      usuario: this._sessionService.getUserSession(),
      accion: 1,
      identTabla: consecutivo
    };
    this._simuladorServices.AmortizacionSimulaComision(payload).subscribe({
      next: (res) => {},
      error: (err) => {
        console.log(err);
      }
    });
  }

  CargaInfoTabla(xi: any) {
    this.dataSource = xi || [];
  }

  CargaInfoTablaEfectivo(fi: any) {
    // Calcular la suma de la columna 'valor' y 'valoriva'
    const totalValor = fi.reduce((acc, item) => acc + parseFloat(item.valor || 0), 0);
    const totalImpuesto = fi.reduce((acc, item) => acc + parseFloat(item.valoriva || 0), 0);
    const granTotal = totalValor + totalImpuesto;

    // Crear la fila de Total
    const filaTotal = {
      descripcion: 'Total',
      valor: parseFloat(totalValor.toFixed(2)),
      valoriva: parseFloat(totalImpuesto.toFixed(2))
    };

    // Crear la fila de Gran Total
    const filaGranTotal = {
      descripcion: '',
      valor: null,
      valoriva: parseFloat(granTotal.toFixed(2))
    };

    const nuevosDatos = [...fi, filaTotal, filaGranTotal];

    this.efectivosource = nuevosDatos;
  }

  cargarTerm() {
    this._simuladorServices.getTerm(this.promocion).subscribe((res) => {
      this.terms = res.data;
    });
  }

  cargarCicle() {
    this._simuladorServices.getCicle(this.promocion).subscribe((res) => {
      this.cicles = res.data;
    });
  }

  cargarPayments() {
    this._simuladorServices.getProDefiniciones().subscribe((res) => {
      this.payments = res.data;
    });
  }

  cargarTermsPlazos() {
    this._simuladorServices.getPromocionesPlazos(this.promocion, this.numvarPlazos).subscribe((res) => {
      this.termsNumVar = res.data;
    });
  }

  atras() {
    this._location.back();
  }

  simular() {
    if (this.form.invalid) {
      this._swalService.error('Por favor, completa todos los campos obligatorios.');
      return;
    }
    this.loading = true;
    this.isSimulando = true;
    // Ejecutar acciones 3, 0 y 1 en secuencia
    this.GetAmortizacionValoresSimula(3);
  }
}
